import React, { useState } from "react";
import "../../../styles/Auth/report.css";
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
const ReportHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const activeReport = location.pathname.split("/").pop();
    return (
        <div className="Report-Header">
            <div
                className={`Summary-Report ${activeReport === "summary" ? "active" : ""}`}
                onClick={() => navigate("/reports/summary")}
            >
                <div className="Summary">
                    <span>Summary Report</span>
                </div>
            </div>
            <div
                className={`Earning-Report ${activeReport === "earning" ? "active" : ""}`}
                onClick={() => { navigate("/reports/earning") }}
            >
                <div className="Earning">
                    <span>Earning Report</span>
                </div>
            </div>

            <div
                className={`Sales-Report ${activeReport === "sales" ? "active" : ""}`}
                onClick={() => navigate("/reports/sales")}
            >
                <div className="Sales">
                    <span>Sales Report</span>
                </div>
            </div>

            <div
                className={`ProfitAndLoss-Report ${activeReport === "profitandloss" ? "active" : ""}`}
                onClick={() => navigate("/reports/profitandloss")}
            >
                <div className="ProfitAndLoss">
                    <span>Profit And Loss Report</span>
                </div>
            </div>


            {/* <div
                className={`Customer-Report ${activeReport === "customer" ? "active" : ""}`}
                onClick={() => navigate("/reports/customer")}
            >
                <div className="Customer">
                    <span>Customer Report</span>
                </div>
            </div> */}
        </div>
    );
};

export default ReportHeader;
